import { render, staticRenderFns } from "./NoauthLayout.vue?vue&type=template&id=68b529d5&scoped=true&"
var script = {}
import style0 from "./NoauthLayout.vue?vue&type=style&index=0&id=68b529d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b529d5",
  null
  
)

export default component.exports